import React, {Component} from 'react';
import Switch from "react-switch";
import scrollToComponent from 'react-scroll-to-component';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";


class HelpOurTeam extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;

        this.state = {
            arrival: this.localState.arrival || '',

            parking: this.localState.parking !== false,
            access: this.localState.access !== false,

            parking_description: this.localState.parking_description || '',
            access_description: this.localState.access_description || '',
            additional_description: this.localState.additional_description || '',

            parking_description_error: this.localState.parking_description_error || false,
            parking_description_error_message: this.localState.parking_description_error_message || '',

            access_description_error: this.localState.access_description_error || false,
            access_description_error_message: this.localState.access_description_error_message || '',

            helpStepValid: this.localState.helpStepValid || false,
            helpStepErrorMessage: this.localState.helpStepErrorMessage || '',

            variation: this.props.variation,
            arrivals: this.props.arrivals.filter(arrival => arrival.variation.type == this.props.variation),

            toggleConfirmation: false
        };

        this.handleDayClick = this.handleDayClick.bind(this);

        this.handleParkingCheckboxChange = this.handleParkingCheckboxChange.bind(this);
        this.handleAccessCheckboxChange = this.handleAccessCheckboxChange.bind(this);

        this.handleTextInputChange = this.handleTextInputChange.bind(this);
        this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
        this.validateTextInput = this.validateTextInput.bind(this);
        this.submitStep = this.submitStep.bind(this);
        this.handleArrivalChange = this.handleArrivalChange.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.changeVariation = this.changeVariation.bind(this);

        this.props.variation == 'man_and_van'
            ? ga('set', 'page', '/wizard/man-and-van/step-4/collection-options')
            : ga('set', 'page', '/wizard/skip/step-4/delivery-options');

        ga('send', 'pageview');
    }

    componentDidUpdate(oldProps) {
        const newProps = this.props;
        if (oldProps.variation !== newProps.variation) {
            this.setState({
                    variation: newProps.variation
                }, () => this.setState({
                    arrivals: this.props.arrivals.filter(arrival => arrival.variation.type == this.props.variation)
                })
            )
        }
    }


    toggleConfirmation() {
        this.setState({
            diffModal: !this.state.diffModal
        });
    }

    handleDayClick(day, modifiers = {}) {
        if (modifiers.disabled) {
            return;
        }
        this.setState({
            selectedDay: modifiers.selected ? undefined : day,
        }, () => {
            this.localState.selectedDay = modifiers.selected ? undefined : day;
            this.props.globalStateChange(this.localState);
            if (window.innerWidth <= 760) {
                scrollToComponent(this.selectTime, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            }
        });
    }

    handleArrivalChange(e) {
        let arrivals = this.props.arrivals;
        let arrival = arrivals.find(arrival => arrival.id == e.target.value);

        this.setState({
            arrival: arrival
        }, () => {
            this.localState.arrival = arrival;
            this.props.globalStateChange(this.localState);
            this.props.updatePrice();
        });
    }

    handleParkingCheckboxChange() {
        this.setState({
            parking: !this.state.parking
        }, () => {
            if (this.state.parking) {
                this.setState({
                    parking_description: ''
                })
            }
            this.localState.parking = this.state.parking;
            this.props.globalStateChange(this.localState);
        })
    }

    handleAccessCheckboxChange() {
        this.setState({
            access: !this.state.access
        }, () => {
            if (this.state.access) {
                this.setState({
                    access_description: ''
                })
            }
            this.localState.access = this.state.access;
            this.props.globalStateChange(this.localState);
        })
    }

    handleTextInputChange(e) {
        let name = [e.target.name];
        let error = [e.target.name] + '_error';
        let message = [e.target.name] + '_error_message';

        if ([e.target.name] == 'email') {
            this.setState({
                email_error: false,
                email_error_messsage: ''
            });
        }

        this.setState({
            [error]: false,
            [message]: '',
            [e.target.name]: e.target.value
        }, () => {
            this.localState[name] = this.state[name];
            this.props.globalStateChange(this.localState);
        });
    }

    handleSelectTime(e, index) {
        e.preventDefault();
        let state = this.state;

        state.times.map((time, i) => {
            time.selected = false
        });

        state.times[index].selected = !state.times[index].selected;

        state.time_selected = state.times.filter(time => time.selected === true);

        this.setState({
            state: state
        }, () => {
            this.localState.time_selected = this.state.time_selected;
            this.localState.times = this.state.times;
            this.props.globalStateChange(this.localState);
            if (window.innerWidth <= 760) {
                scrollToComponent(this.confirmAddress, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            }
        });
    }

    changeVariation() {
        this.props.changeVariation();
        this.toggleConfirmation();
    }

    handleTextAreaChange(e) {
        let name = [e.target.name];
        let error = [e.target.name] + '_error';
        let message = [e.target.name] + '_error_message';

        this.setState({
            [e.target.name]: e.target.value,
            [error]: false,
            [message]: ''
        }, () => {
            this.localState[name] = this.state[name];
            this.localState[error] = this.state[error];
            this.localState[message] = this.state[message];
        });
    }

    validateTextInput(e) {
        if (e.target.value.length > 254 || e.target.value.length < 2) {
            let error = [e.target.name] + '_error';
            let message = [e.target.name] + '_error_message';

            this.setState({
                [error]: true,
                [message]: 'Input text should be between 2 and 254 characters long'
            }, () => {
                this.localState[error] = this.state[error];
                this.localState[message] = this.state[message];
            });
        }

        if (e.target.name == 'property_number') {
            if (e.target.value.length > 254 || e.target.value.length < 1) {
                let error = [e.target.name] + '_error';
                let message = [e.target.name] + '_error_message';

                this.setState({
                    [error]: true,
                    [message]: 'Input text should be at least 1 character long'
                });
            }
        }
    }

    submitStep() {
        if (!this.state.parking && (this.parkingDescription.value == '' || this.parkingDescription.value == null)) {
            this.setState({
                parking_description_error: true,
                parking_description_error_message: 'This field is required'
            }, () => {
                this.localState.parking_description_error = this.state.parking_description_error;
                this.localState.parking_description_error_message = this.state.parking_description_error_message;
            });
        }

        if (!this.state.access && (this.accessDescription.value == '' || this.accessDescription.value == null)) {
            this.setState({
                access_description_error: true,
                access_description_error_message: 'This field is required'
            }, () => {
                this.localState.access_description_error = this.state.access_description_error;
                this.localState.access_description_error_message = this.state.access_description_error_message;
            });
        }

        if (
            !this.state.parking_description_error &&
            !this.state.access_description_error
        ) {
            this.setState({
                helpStepValid: true
            });
            this.localState.parking = this.state.parking;
            this.localState.parking_description = this.state.parking_description;
            this.localState.access = this.state.access;
            this.localState.access_description = this.state.access_description;
            this.localState.additional_description = this.state.additional_description;

            this.props.setValidity(true);
            this.props.globalStateChange(this.localState);
            this.props.nextStep();
        } else {
            this.setState({
                helpStepErrorMessage: 'This step is not completed. Please fill out required fields labeled with *'
            });
        }
    }

    render() {
        return (
            <section id="collection">
                <div className="container pb-5">
                    <div className="row justify-content-center pb-3">
                        <h2 className="wizard-heading pt-sm-0 pt-5 px-3">
                            {this.state.variation == 'skip' ? 'Choose your delivery option' : 'When would you like your waste collected?'}
                        </h2>
                    </div>
                    <div className="row justify-content-center ">
                        <div className="col-md-10 justify-content-center">
                            <div className="card ">
                                <div className="card-body card-wizard">
                                    <div className="form-group pt-3">
                                        <select name="time_selected" className='form-control'
                                                defaultValue={this.localState.arrival || 'select'}
                                                onChange={(e) => this.handleArrivalChange(e)}>
                                            <option value='select' disabled>Select...</option>
                                            {this.state.arrivals.map((arrival) => {
                                                if (arrival.type === 'next_day') {
                                                    return (
                                                        <option key={arrival.id}
                                                                value={arrival.id}>{arrival.name} (+&#163;{arrival.additional_fee / 100})
                                                            - if order submitted before {this.props.cut_off}</option>
                                                    )
                                                }
                                                return (
                                                    <option key={arrival.id}
                                                            value={arrival.id}>{arrival.name} {arrival.from == arrival.to ? `(${arrival.from} days)` : `(${arrival.from}-${arrival.to} days)`}</option>
                                                )
                                            })}
                                        </select>
                                        <div className="mt-1">
                                            <small
                                                style={{color: '#FDB913'}}>* {this.state.variation == 'skip' ? 'Deliveries ' : 'Collections '} are
                                                made Mon - Fri
                                                (excluding bank
                                                holidays).
                                            </small>
                                            {/*{this.props.variation == 'skip' &&*/}
                                            {/*<small style={{color: '#FDB913'}}>*/}
                                            {/*<br/>*/}
                                            {/*<span className='text-danger'><b><i className='fa fa-space-shuttle'> </i> Do you need your waste gone sooner?</b></span> No problem! We’ve got you covered. We can collect your waste earlier than a delivery of a skip through our Man & Van service.*/}
                                            {/*<a href='#' style={{textDecoration: 'none'}} className='text-danger'> <u>Click here</u></a> to switch.*/}
                                            {/*</small>*/}
                                            {/*}*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.props.variation == 'skip' &&
                            <div className="pt-3">
                                <span style={{color: '#FDB913'}}><b>Do you need your waste gone sooner?</b></span>
                                <br/> No problem! We’ve got you covered. We can collect your waste earlier than a delivery of a skip through our Man & Van service.
                                <span className='prohibited-items' onClick={this.toggleConfirmation}> <u>Click here</u></span> to switch.
                            </div>
                            }
                        </div>
                    </div>
                </div>
                {(this.state.arrival !== '' && this.state.variation == 'man_and_van') &&
                <React.Fragment>
                    <React.Fragment>
                        <div className='container pb-5'>
                            <div className="row justify-content-center py-3">
                                <h2 className="wizard-heading">Help our collection team</h2>
                            </div>
                            <div className="row justify-content-center ">
                                <div className="col-md-10 justify-content-center">
                                    <div className="card ">
                                        <div className="card-body card-wizard">
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Parking</small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10 text-white">
                                                    <span className="span-switch">Can we park within 50 metres of your junk and for free?</span>
                                                    <span className="float-sm-right float-left mt-2 span-switch">
                        <Switch
                            name='parking'
                            className="react-switch"
                            onChange={this.handleParkingCheckboxChange}
                            checked={this.state.parking}
                            aria-labelledby="neat-label"
                            offColor='#ccc'
                        />
                        </span>
                                                </div>
                                            </div>
                                            {!this.state.parking &&
                                            <div className="form-group row">
                                                <div className="col-md-10 offset-md-2 text-white">
                        <textarea name="parking_description"
                                  ref={input => {
                                      this.parkingDescription = input;
                                  }}
                                  maxLength="254"
                                  className='form-control'
                                  onChange={(e) => this.handleTextAreaChange(e)}
                                  cols="30" rows="3"
                                  value={this.state.parking_description}
                                  placeholder='max 254 characters...'></textarea>
                                                    {this.state.parking_description_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.parking_description_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Access</small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10 text-white">
                                                    <span className='span-switch'>Is the junk outside and easily accessible?</span>
                                                    <span className="float-sm-right float-left mt-2 span-switch">
                        <Switch
                            name='access'
                            className="react-switch"
                            onChange={this.handleAccessCheckboxChange}
                            checked={this.state.access}
                            aria-labelledby="neat-label"
                            offColor='#ccc'
                        />
                        </span>
                                                </div>
                                            </div>
                                            {!this.state.access &&
                                            <div className="form-group row">
                                                <div className="col-md-10 offset-md-2 text-white">
                        <textarea name="access_description" className='form-control'
                                  onChange={(e) => this.handleTextAreaChange(e)}
                                  ref={input => {
                                      this.accessDescription = input;
                                  }}
                                  cols="30" rows="3"
                                  maxLength="254"
                                  value={this.state.access_description}
                                  placeholder='max 254 characters...'></textarea>
                                                    {this.state.access_description_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.access_description_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Useful info</small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10 text-white">
                                                    <span>Any other info you think might help the collection team?</span>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-10 offset-md-2 text-white">
                        <textarea name="additional_description" className='form-control'
                                  onChange={(e) => this.handleTextAreaChange(e)}
                                  cols="30" rows="3"
                                  maxLength="254"
                                  value={this.state.additional_description}
                                  placeholder='max 254 characters...'></textarea>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.state.helpStepErrorMessage !== '' &&
                        <div className="row justify-content-center pb-5 mx-3">
                            <div className="alert alert-danger col-md-6">{this.state.helpStepErrorMessage}</div>
                        </div>
                        }

                    </React.Fragment>
                </React.Fragment>
                }

                {this.state.arrival &&
                <div className='container'>
                    <div className="row justify-content-center pb-5">
                        <button className="btn btn-round btn-cw btn-back py-3 mx-2"
                                onClick={this.props.prevStep}>Back
                        </button>

                        <button className="btn btn-round btn-next btn-cw btn-yellow py-3 mx-2"
                                onClick={this.submitStep}>
                            Next
                        </button>
                    </div>
                </div>
                }


                {!this.state.arrival &&
                <div className='container'>

                    <div className="row justify-content-center pb-5">
                        <button className="btn btn-round btn-cw btn-back py-3 mx-2" onClick={this.props.prevStep}>Back
                        </button>

                    </div>
                </div>
                }

                {this.props.variation == 'skip' &&
                <Modal isOpen={this.state.diffModal} toggle={this.toggleConfirmation} className='modal-dialog modal-lg'>
                    <ModalHeader toggle={this.toggleConfirmation}>Are you sure?</ModalHeader>
                    <ModalBody>
                        <p>You are about to change your current order to hire a <b>{this.props.size.size.size_uk}</b> skip to the equivalent Man & Van waste collection option, which is <b>{this.props.size.size.relative.size_uk} CY</b>.</p>
                        <p>Currently this will save you <b>&#163;{(this.props.size.size.price - this.props.size.size.relative.price) / 100}</b>. Extras can now be added to your collection in step 2.</p>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-round py-3 btn-cw btn-back' onClick={this.toggleConfirmation}>Cancel</button>
                        <button className='btn btn-round py-3 btn-cw btn-yellow' onClick={this.changeVariation}>Continue</button>
                    </ModalFooter>
                </Modal>
                }

            </section>
        );
    }
}


export default HelpOurTeam;
